<template>
  <div :class="$style.frameParent">
    <div :class="$style.sign_in">
      <a href="#" @click.prevent="toggleModal">Sign In</a>
    </div>
    <div :class="$style.frameGroup">
      <h2>{{ title }}</h2>
      <div :class="$style.label">Name</div>
      <div :class="$style.frameDiv">
        <div :class="$style.firstWrapper">
          <input type="text" v-model="form.firstName" placeholder="First..." />
        </div>
        <div :class="$style.firstWrapper">
          <input type="text" v-model="form.lastName" placeholder="Last..." />
        </div>
      </div>
      <div :class="$style.label">Birthday</div>
      <div :class="$style.frameDiv">
        <div :class="$style.firstWrapper">
          <HiloSelect
            :theme="'grey'"
            v-model="form.birthday.month"
            :options="months"
            :placeholder="'Month...'"
            :customStyle="{
              height: '50px',
              width: '100%',
              padding: '10px',
            }"
          />
        </div>
        <div :class="$style.firstWrapper">
          <input
            v-model="form.birthday.day"
            type="number"
            :min="1"
            :max="31"
            placeholder="Day..."
          />
        </div>
        <div :class="$style.firstWrapper">
          <input
            v-model="form.birthday.year"
            type="number"
            :min="1900"
            :max="2025"
            placeholder="Year..."
          />
        </div>
      </div>
      <div :class="$style.frameDiv">
        <div :class="$style.locationParent">
          <div :class="$style.name">Address</div>
          <div :class="$style.cityStateWrapper">
            <input
              v-model="form.address1"
              type="text"
              placeholder="Address..."
            />
          </div>
        </div>
      </div>
      <div :class="$style.frameDiv">
        <div :class="$style.locationParent">
          <div :class="$style.name">City</div>
          <div :class="$style.cityStateWrapper">
            <input
              v-model="form.city"
              type="text"
              placeholder="City..."
              :class="{
                invalidValue: form.city && !cityStateRegex.test(form.city),
              }"
            />
          </div>
        </div>
        <div :class="$style.locationParent">
          <div :class="$style.name">State</div>
          <div :class="$style.cityStateWrapper">
            <input
              v-model="form.state"
              type="text"
              placeholder="State..."
              :class="{
                invalidValue: form.state && !cityStateRegex.test(form.state),
              }"
            />
          </div>
        </div>
        <div :class="$style.locationParent">
          <div :class="$style.name">Zip</div>
          <div :class="$style.cityStateWrapper">
            <input v-model="form.zip" type="text" placeholder="Zip..." />
          </div>
        </div>
      </div>
      <div :class="$style.frameDiv">
        <div :class="$style.locationParent">
          <div :class="$style.name">Phone</div>
          <div :class="$style.cityStateWrapper">
            <input
              v-model="form.phone"
              type="text"
              placeholder="Phone number..."
              :class="{
                invalidValue: form.phone && !phoneRegex.test(form.phone),
              }"
            />
          </div>
        </div>
      </div>
      <div :class="$style.frameDiv">
        <div :class="$style.locationParent">
          <div :class="$style.name">Email</div>
          <div :class="$style.cityStateWrapper">
            <input
              v-model="form.email"
              type="email"
              placeholder="Email..."
              @blur="checkEmailExists"
              :class="{
                invalidValue:
                  (form.email && !emailRegex.test(form.email)) || emailExists,
              }"
            />
          </div>
          <p v-if="emailExists" class="error-message">
            An account with this email already exists. Sign in or use a
            different email.
          </p>
        </div>
      </div>
      <div :class="$style.label">Password</div>
      <div :class="$style.frameDiv">
        <div :class="$style.typePasswordParent">
          <input
            v-model="form.password"
            :type="showPassword1 ? 'text' : 'password'"
            placeholder="Type password..."
          />
          <img
            src="/static/img/ViewPassword.svg"
            alt=""
            @click="togglePassword1Visibility"
          />
        </div>
        <div :class="$style.typePasswordParent">
          <input
            v-model="form.confirmPassword"
            :type="showPassword2 ? 'text' : 'password'"
            placeholder="Re-type password..."
          />
          <img
            src="/static/img/ViewPassword.svg"
            alt=""
            @click="togglePassword2Visibility"
          />
        </div>
      </div>
      <div :class="$style.nameParent">
        <div :class="$style.name">Which best describes your current role?</div>
        <div :class="$style.chooseOneParent">
          <HiloSelect
            :theme="'grey'"
            v-model="form.userTypeId"
            :options="userTypes"
            :placeholder="'Choose one...'"
            :customStyle="{
              height: '50px',
              width: '100%',
              padding: '10px',
            }"
            @change="handleRoleChange"
          />
        </div>
      </div>
      <div
        :class="$style.byCreatingAnContainer"
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <input
          type="checkbox"
          id="agreeTerms"
          v-model="form.agreeTerms"
          style="margin-left: 10px"
        />
        <label for="agreeTerms" style="flex: 1">
          <span>By creating an account, I agree to Hilo’s</span>
          <span :class="$style.privacyPolicy"> Privacy Policy </span>
          <span>and </span>
          <span :class="$style.privacyPolicy">Terms of Service.</span>
        </label>
      </div>
      <div :class="$style.createAccountWrapper" @click="onCreateAccountClick">
        <b :class="$style.name">Create Account</b>
      </div>
    </div>
    <div :class="$style.frameChild3" />

    <!--SignIn Modal-->
    <div
      v-if="showModal"
      :class="$style.modal_overlay"
      @click="closeModal"
      id="test"
    >
      <div :class="$style.modal" @click.stop>
        <span :class="$style.close" @click="closeModal">&times;</span>
        <h2>Sign In</h2>
        <input type="email" placeholder="Email" v-model="loginForm.email" />
        <input
          type="password"
          placeholder="Password"
          v-model="loginForm.password"
        />
        <button type="button" @click="login" :disabled="isLoggingIn">
          {{ isLoggingIn ? "Signing In..." : "Sign In" }}
        </button>
        <p v-if="loginError" class="error" style="margin-top: 10px">
          {{ loginError }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import UsersAPIService from "../../../../../servicehandlers/UsersAPIService";
const usersAPIService = new UsersAPIService();
import SignUpAPIService from "../../../../../servicehandlers/SignUpAPIService";
const signUpAPIService = new SignUpAPIService();
import dayjs from "dayjs";
import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";

export default defineComponent({
  components: { HiloSelect },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  name: "SignUpForm",
  data() {
    return {
      form: {
        firstName: "",
        lastName: "",
        birthday: {},
        address1: "",
        city: "",
        state: "",
        zip: "",
        phone: "",
        email: "",
        password: "",
        confirmPassword: "",
        userTypeId: "",
        agreeTerms: false,
      },
      months: [
        { id: 1, name: "January" },
        { id: 2, name: "February" },
        { id: 3, name: "March" },
        { id: 4, name: "April" },
        { id: 5, name: "May" },
        { id: 6, name: "June" },
        { id: 7, name: "July" },
        { id: 8, name: "August" },
        { id: 9, name: "September" },
        { id: 10, name: "October" },
        { id: 11, name: "November" },
        { id: 12, name: "December" },
      ],
      emailRegex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      phoneRegex: /^(?:\(\d{3}\)\s?|\d{3}[-\s]?)\d{3}[-\s]?\d{4}$/,
      cityStateRegex: /^[A-Za-z\s]+$/,
      validations: [
        { field: "firstName", desc: "first name" },
        { field: "lastName", desc: "last name" },
        { field: "birthday.month", desc: "birthday" },
        { field: "birthday.day", desc: "birthday" },
        { field: "birthday.year", desc: "birthday" },
        { field: "address1", desc: "address" },
        { field: "city", regex: "cityStateRegex", desc: "city" },
        { field: "state", regex: "cityStateRegex", desc: "state" },
        { field: "zip", desc: "zip" },
        { field: "phone", regex: "phoneRegex", desc: "phone number" },
        { field: "email", regex: "emailRegex", desc: "email address" },
        { field: "password", desc: "password" },
        { field: "confirmPassword", desc: "confirmed password" },
        { field: "userTypeId", desc: "current role" },
        { field: "agreeTerms", desc: "agree terms" },
      ],
      userTypes: [],
      showModal: false,
      loginForm: {
        email: "",
        password: "",
      },
      isLoggingIn: false,
      loginError: "",
      emailExists: false,
      showPassword1: false,
      showPassword2: false,
    };
  },
  mounted() {
    this.getUserTypes();
  },
  methods: {
    getUserTypes() {
      return usersAPIService
        .getUserTypes(this.$router)
        .then((types) => {
          this.userTypes = types.filter(
            (type) => type.name === "Student" || type.name === "Lender",
          );
        })
        .catch((error) => {});
    },
    handleRoleChange(userTypeId) {
      this.$emit("onRoleChange", userTypeId);
    },
    async checkEmailExists() {
      if (!this.emailRegex.test(this.form.email)) {
        this.emailExists = false;
        return;
      }
      try {
        const response = await signUpAPIService.checkEmail(
          this.form.email,
          this.$router,
        );
        this.emailExists = response.exists;
      } catch (error) {}
    },
    async onCreateAccountClick() {
      let isValid = true;
      for (const validation of this.validations) {
        const { field, desc, regex } = validation;

        const fieldValue = field
          .split(".")
          .reduce((obj, key) => obj && obj[key], this.form);

        if (!fieldValue) {
          isValid = false;
          if (field === "agreeTerms" && !this.form.agreeTerms) {
            alert(`Please agree to the terms`);
          } else {
            alert(`Please enter a ${desc}`);
          }
          break;
        }

        if (regex && !this[regex].test(this.form[field])) {
          isValid = false;
          alert(`Please enter a valid ${desc}`);
          break;
        }
      }

      if (!isValid) return;

      if (this.emailExists) {
        alert("Please use a different email or sign in.");
        return;
      }

      if (this.form.password !== this.form.confirmPassword) {
        alert("Passwords do not match!");
        return;
      }

      const dob = dayjs(
        `${this.form.birthday.year}-${this.form.birthday.month}-${this.form.birthday.day}`,
      );
      if (!dob.isValid()) {
        alert("Please enter a valid birthday.");
        return;
      }

      delete this.form.confirmPassword;
      delete this.form.birthday;
      const response = await signUpAPIService.createUser({
        ...this.form,
        dob,
      });

      if (response.signUpToken) {
        sessionStorage.setItem("signUpToken", response.signUpToken);
        localStorage.removeItem("jwtToken");
      }

      this.$emit("setUserInfoAndNext", response.user);
    },

    toggleModal() {
      this.showModal = !this.showModal;
    },
    closeModal() {
      this.showModal = false;
    },
    togglePassword1Visibility() {
      this.showPassword1 = !this.showPassword1;
    },
    togglePassword2Visibility() {
      this.showPassword2 = !this.showPassword2;
    },
    async login() {
      if (this.isLoggingIn) return;
      this.isLoggingIn = true;
      try {
        const response = await signUpAPIService.login(this.loginForm);
        this.isLoggingIn = false;
        this.showModal = false;

        if (response.signUpToken) {
          sessionStorage.setItem("signUpToken", response.signUpToken);
          localStorage.removeItem("jwtToken");
        }

        this.$emit("setUserInfoAndNext", response.user, response.nextPage);
      } catch (error) {
        this.isLoggingIn = false;
        this.loginError = "Invalid email or password. Please try again.";
      }
    },
  },
});
</script>

<style module scoped>
.name {
  position: relative;
}

.firstWrapper {
  flex: 1;
  border-radius: 10px;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
}

.nameParent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}

.cityStateWrapper {
  align-self: stretch;
  border-radius: 10px;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  color: rgba(64, 64, 64, 0.5);
}

.locationParent {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}

.frameDiv {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}

.typePasswordParent {
  flex: 1;
  border-radius: 10px;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  position: relative;
}

.typePasswordParent img {
  position: absolute;
  right: 12px;
  cursor: pointer;
}

.chooseOneParent {
  width: 100%;
  position: relative;
}

.createAccountWrapper {
  align-self: stretch;
  border-radius: 10px;
  background-color: #3c78ff;
  height: 50px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  color: #fff;
  transition: 0.2s ease-in-out;
}

.createAccountWrapper:hover {
  opacity: 0.8;
}

.privacyPolicy {
  color: #3c78ff;
}

.byCreatingAnContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 15px;
  color: rgba(64, 64, 64, 0.75);
}
.byCreatingAnContainer label {
  flex: 1;
  font-size: 14px;
}

.byCreatingAnContainer input[type="checkbox"] {
  margin-right: 10px;
  margin-top: -8px;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.frameGroup {
  align-self: stretch;
  background-color: #fff;
  overflow-y: auto;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  box-sizing: border-box;
  gap: 30px;
  z-index: 1;
}

.frameChild3 {
  align-self: stretch;
  flex: 1;
  background-color: #f7f9fa;
  z-index: 0;
}

.frameParent {
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
}

/*noinspection CssUnusedSymbol */
:global(input.invalidValue) {
  border: 2px solid red !important;
}
.label {
  width: 100%;
  margin-bottom: -20px;
}

/*Modal*/
.sign_in {
  position: relative;
  top: 10px;
  right: 0;
  z-index: 10;
  display: flex;
  justify-content: flex-end;
}

.sign_in a {
  color: #007bff;
  text-decoration: none;
}

.sign_in a:hover {
  text-decoration: underline;
}

.modal_overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  z-index: 1000;
}

.modal {
  position: fixed;
  top: 10%;
  background: white;
  padding: 20px;
  border-radius: 5px;
  height: 380px;
  width: 350px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.close {
  position: relative;
  align-self: flex-end;
  right: 10px;
  font-size: 20px;
  cursor: pointer;
}

.modal input {
  width: 100%;
  padding: 3px 20px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 50px;
}

.modal img {
  position: absolute;
  right: 28px;
  cursor: pointer;
}

.modal button {
  width: 100%;
  padding: 10px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 10px;
}

.modal button:hover {
  background: #0056b3;
}

.error-message {
  color: red;
  font-size: 12px;
  margin-top: 5px;
}
</style>
